<template>
  <mdb-container fluid>
    
    <div
      class="view"
      style="background-image: url(/img/it.jpg); height: 60vh; background-repeat: no-repeat; background-size: cover; background-position: center center;"
    >
      <div class="mask rgba-black-light">
        <div
          class="container h-100 d-flex justify-content-center align-items-center"
        >
          <div class="row pt-5 mt-3">
            <div class="col-md-12">
              <div class="text-center">
                <h1
                  class="h1-reponsive white-text text-uppercase font-weight-bold mb-3 wow fadeInDown"
                  data-wow-delay="0.3s"
                >
                  <strong>اخبار و رویداد ها</strong>
                </h1>
                <hr
                  class="hr-light mt-4 wow fadeInDown"
                  data-wow-delay="0.4s"
                />
                <h5
                  class="text-uppercase mb-5 white-text wow fadeInDown"
                  data-wow-delay="0.4s"
                >
                  <strong>پوشش اخبار و رویدادهای موثر در سرویس دهی</strong>
                </h5>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <section
        class="section extra-margins my-5 text-center text-lg-rigth wow fadeIn"
        data-wow-delay="0.3s">

        <div class="row hover" 
          @click="showAnnouncement(announce)"
          v-for="announce in dataItems" 
          :key="announce.AnnouncementId">
           
         
          <div class="col-lg-4 mb-4">
            
            <div class="view overlay z-depth-1">
              <img
                :src="announce.Image"
                class="img-fluid"
                :alt="announce.Title"
              />
              <a>
                <div class="mask rgba-white-slight"></div>
              </a>
            </div>
          </div>

          <div class="col-lg-7 mb-4">
            
            <h4 class="mb-4"><strong v-text="announce.Title"></strong></h4>
            <span v-text="announce.Publish"></span>
            <!-- <a class="btn btn-primary">بیشتر</a> -->
          </div>

          
          <hr class="col-12 mb-5 mt-3" />
        </div>


        <nav
          class="wow fadeIn mb-4 mt-5"
          data-wow-delay="0.4s"
          style="visibility: visible; animation-delay: 0.4s; animation-name: fadeIn;"
        >
          <ul class="pagination pg-dark flex-center">

            <li class="page-item">
              <a
                class="page-link waves-effect waves-effect"
                aria-label="Previous"
                v-if="canPrev" @click="setPage(-1)"
              >
                <span aria-hidden="true">«</span>
                <span class="sr-only">قبلی</span>
              </a>
            </li>


            <li class="page-item" v-if="canPrev">
              <a class="page-link waves-effect waves-effect" @click="setPage(-1)" v-text="(page+1)-1"></a>
            </li>
            <li class="page-item active">
              <a class="page-link waves-effect waves-effect" v-text="(page+1)"></a>
            </li>
            <li class="page-item" v-if="canNext">
              <a class="page-link waves-effect waves-effect" @click="setPage(1)" v-text="(page+1)+1"></a>
            </li>

            <li class="page-item">
              <a class="page-link waves-effect waves-effect" @click="setPage(1)" aria-label="Next" v-if="canNext">
                <span aria-hidden="true">»</span>
                <span class="sr-only">بعدی</span>
              </a>
            </li>
          </ul>
        </nav>

      </section>

    </div>
  </mdb-container>

</template>

<script>
import {
  mdbContainer,
  mdbNavbar,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbInput,
  mdbNavbarBrand,
} from "mdbvue";

import announcementApi from "@/api/announcementApi";

export default {
  name: "Post",
  components: {
    mdbContainer,
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbInput,
    mdbNavbarBrand,
  },
  data() {
    return {
      ds:null,
      page:0,
      pageSize:6
    };
  },
  mounted() {
    announcementApi.getAnnouncements().then(
      ({ data }) => {
        this.ds = data;
      },
      (r) => {}
    );
    
  },
  methods:{
    setPage(index){
      this.page += index;
    },
    showAnnouncement(announce){      
      this.$router.push({name: 'Announcement', params: { announcementId: announce.AnnouncementId }});
    }
  },
  computed:{
    dataItems: function(){
      if (this.ds == null)
        return [];
      let ds = Object.assign([], this.ds);
      return ds.splice(this.page*this.pageSize,this.pageSize);
    },
    canNext(){
      if(this.ds == null){
        return false;
      }
      else if(this.ds.length <= this.pageSize * (this.page+1))
      {
        return false;
      }
      console.log('canNext',this.ds.length , this.pageSize , this.page);
      return true;
    },
    canPrev(){
      if(this.ds == null){
        return false;
      }
      else if(this.page <= 0)
      {
        return false;
      }
      return true;
    }
  },
  watch:{
    page(oldValue,newValue){
      // var ds = this.ds;
      // this.ds = [];
      // this.ds = ds;
    }
  },
};
</script>

<style scoped>
.navbar {
  background: transparent;
}
</style>
